import React  from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import './Information.scss';
import { setScreen, setAllObjectConsentSwitch } from '../../../redux/actions';
import { switchScreenButton } from '../../../scripts/lib/handlers';
import getNameFromUrl from '../../../scripts/lib/getNameFromUrl';

const Information = props => {

    const filtersAllowed = {'specialPurposes': 1,'specialFeatures':1};
    
    const { configuration } = props;
    //debugger;

    let currentLanguage = props.currentLanguage;
    if(currentLanguage && configuration && configuration.domesticLanguages && configuration.domesticLanguages[currentLanguage.code+"-dom"]){
        currentLanguage = configuration.domesticLanguages[currentLanguage.code+"-dom"];
    }
    const { intro, thirdParties, legitimateInterest } = currentLanguage.text;
    // props.setAllObjectConsentSwitch(true);

    const thirdPartiesUrl = (index) => { 
        return (<span className="link" key={`intro_${index}`} onClick={() => switchScreenButton(configuration)}>{thirdParties || 'third parties'}</span>)
    }

    const legitimateInterestUrl = (index) => {
        const {legitimateInterestUrl} = currentLanguage;
        return (<a key={`intro_${index}`} href={legitimateInterestUrl || 'https://eur-lex.europa.eu/legal-content/EN/TXT/HTML/?uri=CELEX:32016R0679&amp;from=EN#d1e1489-1-1'} target="_blank" rel="noopener noreferrer">{legitimateInterest || 'legitimate Interest'} <span className="icon-external-link"></span></a>)
    }

    const renderFilterButtons = (filterName) => {
        if (currentLanguage && currentLanguage.vendorList && currentLanguage.vendorList[filterName]) {
            try {
                return (
                    <ol key={`ol_${filterName}`} type={(filtersAllowed[filterName] === 1)? 'A' : '1'}>
                        {currentLanguage.vendorList[filterName].map(object => {
                            return (
                                <li key={`${filterName}_${object.id}`}>{object.name}</li>
                            )
                        })}
                    </ol>
                );
            } catch (error) {
                return null;
            }
        } else {
            return null;
        }
    };

    const renderSection = (section) => {
        if (props.configuration && props.configuration.custom && props.configuration.custom.htmlSection && props.configuration.custom.htmlSection) {
            let sectionProperties = null;
            if (props.configuration.custom.htmlSection[props.currentLanguage.code.toLowerCase()]) {
                sectionProperties = props.configuration.custom.htmlSection[props.currentLanguage.code.toLowerCase()];
            } else if (props.configuration.custom.htmlSection['default']) {
                sectionProperties = props.configuration.custom.htmlSection['default'];
            }

            if (sectionProperties) {
                return (
                    <div key={`section-${section}`} >
                        {ReactHtmlParser(sectionProperties[section])}
                    </div>
                )
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    const getInformation = () => {
        let publisherName = '';
        if (props.configuration && props.configuration.publisherName) {
            publisherName = props.configuration.publisherName;
        } else if (window.location && window.location.ancestorOrigins && window.location.ancestorOrigins[0]) {
            publisherName = getNameFromUrl(window.location.ancestorOrigins[0])
        }

        // debugger;
        const replaceVars = {
            "[[publisherName]]": () => publisherName,
            "[[thirdPartiesUrl]]": thirdPartiesUrl,
            "[[legitimateInterestUrl]]": legitimateInterestUrl,
            "[[purposes]]": () => {return renderFilterButtons('purposes')},
            "[[legitimateInterest]]": () => { return renderFilterButtons('specialPurposes')},
            "[[features]]": () => {return renderFilterButtons('specialFeatures')},
            "[[topSection]]": () => {return renderSection('top')},
            "[[bottomSection]]": () => {return renderSection('bottom')}
        }

        return intro.split(new RegExp("(\\[\\[publisherName\\]\\]|\\[\\[thirdPartiesUrl\\]\\]|\\[\\[legitimateInterestUrl\\]\\]|\\[\\[purposes\\]\\]|\\[\\[legitimateInterest\\]\\]|\\[\\[features\\]\\]|\\[\\[topSection\\]\\]|\\[\\[bottomSection\\]\\])")).map((object, index) => {
            if (replaceVars && replaceVars[object]) {
                return replaceVars[object](index);
            } else {
                return (<span key={`intro_${index}`}>{ReactHtmlParser(object)}</span>);
            }
        });
    }

    const createLogo = () => {
        if (props.configuration && props.configuration.logoUrl) {
            return (
                <div id="publisherLogo">
                    <img src={props.configuration.logoUrl} alt="logo" />
                </div>
            )
        } else {
            return null;
        }
    };

    if (currentLanguage.text) {
        return (
            <div id="information">
                {createLogo()}
                <div className="pre">{getInformation()}</div>
            </div>
        );
    } else {
        return (
            null
        )
    }
};

const mapStatetoProps = state => {
    return {...state};
};

export default connect(mapStatetoProps,{setScreen, setAllObjectConsentSwitch})(Information);